//The login form you are shown if you don't have a valid session
import React, {useState} from "react"
import {logIn} from "../service.js";
import menuIcon from "../images/FKC-background-red.png"
export default function Login(){
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [message, setMessage] = useState("")

  function logInButton(){
    setMessage("")
    logIn(username,password)
      .then((status) => {
        if (status === "ok") {
          window.location.reload()
        } else {
          //Server said no: stay on the page, keep the username so it does
          //not have to be re-typed, clear the password, show a message.
          //No failure detail - the server deliberately answers one opaque "bad".
          setPassword("")
          setMessage("Login failed. Check your username and password and try again.")
        }
      })
      .catch(() => {
        //The request never reached the server (bad reception / no network):
        //keep whatever was typed - re-typing a password on bad reception is
        //the last thing anyone wants.
        setMessage("Connection failed. Check your network and try again.")
      })
  }

  function handleUsernameKeystroke(event){
    if (event.key === "Enter") {
      event.preventDefault() // don't submit the form - just move on to the password
      window.document.getElementById("password").focus()
    }
  }

  return (
    <div className="login">
      <div className="navbar--logo">
        <img src={menuIcon} className="navbar--menuIcon"/>
        <h4 className="navbar--title">
          Herbershala.com Meal Planner
        </h4>
      </div>
      {/*Enter in the password field works via the form's default button:
        the browser's implicit submission "clicks" that button, which fires
        the one submit event handled below. A form with no submit button
        does not implicitly submit in real browsers (verified in
        Edge/Chromium against the dev server: Enter fired nothing), so the
        button must be type="submit" - and must not also carry onClick,
        or one action would log in twice.
        (The old onKeyUp binding also failed: iOS Safari does not deliver
        keyup for the return key.)*/}
      <form onSubmit={(event) => {event.preventDefault(); logInButton();}}>
        <input
          id="username"
          className="login--username"
          type="text" placeholder="username"
          value={username}
          onChange={(event) => setUsername(event.target.value)}
          onKeyDown={(event) => handleUsernameKeystroke(event)}
          autoComplete="username"
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck={false}
        />
        <input
          id="password"
          className="login--password"
          type="password" placeholder="password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          autoComplete="current-password"
        />
        <button className="login--submit" type="submit">
          <span className="login--submit-text">
            Log In
          </span>
        </button>
      </form>
      {message !== "" ? <div className="login--message">{message}</div> : null}
    </div>
  )
}